

export default class ServiceMovil {

    constructor () {

        if(typeof ServiceMovil.instance === "object"){
            return ServiceMovil.instance;
        }

        ServiceMovil.instance = this;
        return this;
    }

    guardaCache(typeMovil, enumView, url){
        if(typeMovil === "AndroidMovil"){
            try {
                window.Android.guardaCache(enumView, url);   
            }catch (error) { console.log(error) } 
        }
    }

    deleteCache(typeMovil){
        if(typeMovil === "AndroidMovil"){
            try {
                window.Android.deleteCache();
            }catch (error) { console.log(error)  }     
        }
    }

    processBack(typeMovil){
        if(typeMovil === "AndroidMovil"){
            try {
                window.Android.procesaBack();   
            }catch (error) { console.log(error) } 
        }
    }

    callCamara(typeMovil, typecam, uiidp){
        if(typeMovil === "AndroidMovil"){
            try {
                window.Android.callCamera(typecam,uiidp);  
            }catch (error) { console.log(error) } 
        }
    }

    recomendation(typeMovil, check, pantalla){
        if(typeMovil === "AndroidMovil"){
            try {
                window.Android.setRecomendaciones(check,pantalla);  
            }catch (error) { console.log(error) } 
        }
    }

}